import React, { useState } from 'react';

// Şirket logoları
const companyLogos = {
  Ana: '/insurance-companies/anasigorta.jpg',
  Ankara: '/insurance-companies/ankarasigortalogo.png',
  Axa: '/insurance-companies/axalogo.jpg',
  Corpus: '/insurance-companies/corpus.png',
  HDI: '/insurance-companies/hdisigorta.jpg',
  Emaa: '/insurance-companies/emasigorta.png',
  'Turkiye Katilim': '/insurance-companies/katılım_sigorta_hayat.jpg',
  Hepiyi: '/insurance-companies/hepiyisigorta.jpg',
  Koru: '/insurance-companies/Koru-Logo.png',
  Magdeburger: '/insurance-companies/magdeburgerlogo.jpg',
  Mapfre: '/insurance-companies/mapfre.png',
  Neova: '/insurance-companies/neovasigorta.jpg',
  Anadolu: '/insurance-companies/anadolulogo.jpg',
  Quick: '/insurance-companies/quick.png',
  Ray: '/insurance-companies/raysigorta.jpg',
  Referans: '/insurance-companies/referans.png',
  Sompo: '/insurance-companies/somposigorta.jpg',
  TurkNippon: '/insurance-companies/turknipponsigorta.jpg',
  Unico: '/insurance-companies/unico.png',
  Doga: '/insurance-companies/dogasigorta.jpg',
  Allianz: '/insurance-companies/allianzlogo.jpg',
  Ak: '/insurance-companies/aksigortalogo.jpg',
  Turkiye: '/insurance-companies/turkiyesigorta.jpg',
};

const getCompanyLogo = (code) => companyLogos[code] || null;

// Şirket isimlerini düzelt (API'den kısa geliyor)
const companyDisplayNames = {
  Ana: 'Ana Sigorta',
  Doga: 'Doğa Sigorta',
  Axa: 'Axa Sigorta',
  Emaa: 'Emaa Sigorta',
  'Turkiye Katilim': 'Türkiye Katılım Sigorta',
  Referans: 'Referans Sigorta',
  Mapfre: 'Mapfre Sigorta',
  Allianz: 'Allianz Sigorta',
  Ak: 'Ak Sigorta',
  Turkiye: 'Türkiye Sigorta',
  Ankara: 'Ankara Sigorta',
  Corpus: 'Corpus Sigorta',
  HDI: 'HDI Sigorta',
  Hepiyi: 'Hepiyi Sigorta',
  Koru: 'Koru Sigorta',
  Magdeburger: 'Magdeburger Sigorta',
  Neova: 'Neova Sigorta',
  Anadolu: 'Anadolu Sigorta',
  Quick: 'Quick Sigorta',
  Ray: 'Ray Sigorta',
  Sompo: 'Sompo Sigorta',
  TurkNippon: 'Turk Nippon Sigorta',
  Unico: 'Unico Sigorta',
};

const getDisplayName = (code, name) => companyDisplayNames[code] || (name && !name.toLowerCase().includes('sigorta') ? name + ' Sigorta' : name);

// Araç grubuna göre teminat bilgileri
const coverageData = {
  '01': { group: 'Otomobil / Taksi', saglikKisi: '3.600.000', saglikKaza: '18.000.000', olumKisi: '3.600.000', olumKaza: '18.000.000', maddiArac: '400.000', maddiKaza: '800.000' },
  '02': { group: 'Kamyonet, Kamyon, Çekici', saglikKisi: '3.600.000', saglikKaza: '36.000.000', olumKisi: '3.600.000', olumKaza: '36.000.000', maddiArac: '400.000', maddiKaza: '800.000' },
  '03': { group: 'Tarım ve Özel Amaçlı', saglikKisi: '3.600.000', saglikKaza: '18.000.000', olumKisi: '3.600.000', olumKaza: '18.000.000', maddiArac: '400.000', maddiKaza: '800.000' },
  '04': { group: 'Motosiklet', saglikKisi: '3.600.000', saglikKaza: '10.800.000', olumKisi: '3.600.000', olumKaza: '10.800.000', maddiArac: '400.000', maddiKaza: '800.000' },
  '05': { group: 'Minibüs (10-17 Koltuk)', saglikKisi: '3.600.000', saglikKaza: '8.080.000', olumKisi: '3.600.000', olumKaza: '8.080.000', maddiArac: '400.000', maddiKaza: '800.000' },
  '06': { group: 'Otobüs (18-30 Koltuk)', saglikKisi: '3.600.000', saglikKaza: '21.008.000', olumKisi: '3.600.000', olumKaza: '21.008.000', maddiArac: '400.000', maddiKaza: '800.000' },
  '07': { group: 'Otobüs (31+ Koltuk)', saglikKisi: '3.600.000', saglikKaza: '42.015.000', olumKisi: '3.600.000', olumKaza: '42.015.000', maddiArac: '400.000', maddiKaza: '800.000' },
};

const getCoverage = (vehicleInfo) => {
  if (!vehicleInfo) return coverageData['01'];
  const code = vehicleInfo.substring(0, 2);
  return coverageData[code] || coverageData['01'];
};

// Thinking Dots
const ThinkingDots = React.memo(() => (
  <div className="flex items-center gap-1.5 py-1">
    {[0, 1, 2].map(i => (
      <div
        key={i}
        className="w-2 h-2 bg-[#24b9fa] rounded-full animate-thinking-dot"
        style={{ animationDelay: `${i * 0.2}s` }}
      />
    ))}
  </div>
));

const OnlineTrafikSigortasi3 = ({
  loading, completed, quotes, error,
  customerInfo, formData, totalCompanies,
  hasActivePolicy, policyEndDate,
  systemMessage, pdfUrl,
  typedText, formatPrice, onNewQuery
}) => {

  const [expandedCard, setExpandedCard] = useState(null);
  const coverage = getCoverage(customerInfo.vehicle);

  const sortedQuotes = [...quotes].sort((a, b) => {
    if (!a.premium && !b.premium) return 0;
    if (!a.premium) return 1;
    if (!b.premium) return -1;
    return a.premium - b.premium;
  });

  const successQuotes = sortedQuotes.filter(q => q.premium && q.status !== 'error');
  const failedQuotes = sortedQuotes.filter(q => !q.premium || q.status === 'error');

  return (
    <div className="animate-slide-up">

      {/* Sigo Durum Mesaji */}
      <div className="flex items-start gap-3 mb-5">
        <div className="w-16 h-16 flex-shrink-0">
          <div className={loading ? 'animate-pulse-ring' : 'animate-sigo-float'}>
            <img src="/sigo3.png" alt="Sigo" className="w-full h-full object-contain drop-shadow-md" />
          </div>
        </div>
        <div className="flex-1 bg-white/90 backdrop-blur-sm rounded-2xl rounded-bl-md p-4 shadow-md border border-orange-100/50 relative">
          <div className="absolute -left-2 top-4 w-3 h-3 bg-white border-l border-b border-orange-100/50 transform rotate-45" />
          {loading ? (
            <div>
              <div className="flex items-center gap-2 mb-1">
                <div className="inline-flex items-center gap-1.5 bg-[#ff8e04]/10 text-[#ff8e04] px-2.5 py-0.5 rounded-full text-xs font-semibold">
                  <svg className="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                  SiGo Fiyat Araştırıyor
                </div>
              </div>
              <p className="text-sm text-gray-600">{typedText}</p>
              {quotes.length === 0 && <ThinkingDots />}
              {successQuotes.length > 0 && (
                <p className="text-xs text-green-600 font-medium mt-1">{successQuotes.length} teklif bulundu, taramaya devam ediyorum...</p>
              )}
            </div>
          ) : completed ? (
            <div>
              <div className="flex items-center gap-2 mb-1">
                <div className="inline-flex items-center gap-1.5 bg-green-50 text-green-600 px-2.5 py-0.5 rounded-full text-xs font-semibold">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" /></svg>
                  Fiyat Sorgusu Tamamlandı
                </div>
              </div>
              <p className="text-sm text-gray-600">{typedText}</p>
            </div>
          ) : null}
        </div>
      </div>

      {/* Musteri Bilgi Karti */}
      {customerInfo.name && (
        <div className="bg-gradient-to-r from-[#0189ec] to-[#00c8ff] rounded-2xl p-4 mb-4 text-white shadow-lg shadow-blue-200/30">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-blue-100 text-xs mb-0.5">Araç Sahibi</div>
              <div className="font-bold text-lg">{customerInfo.name}</div>
              {customerInfo.vehicle && (
                <div className="text-blue-50 text-sm mt-0.5">{customerInfo.vehicle}</div>
              )}
            </div>
            <div className="text-right">
              <div className="text-blue-100 text-xs mb-0.5">Plaka</div>
              <div className="font-bold text-lg">{formData.plate}</div>
              {totalCompanies && (
                <div className="text-blue-50 text-sm mt-0.5">{totalCompanies} şirket sorgulanıyor</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Aktif Police Uyarisi */}
      {hasActivePolicy && (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-4 flex items-start gap-3">
          <svg className="w-6 h-6 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
          <div>
            <div className="font-semibold text-amber-800">Aktif Police Mevcut</div>
            <p className="text-sm text-amber-700 mt-0.5">
              Bu araçta aktif bir trafik sigortası poliçesi bulunmaktadır.
              {policyEndDate && <span> Bitiş tarihi: <strong>{policyEndDate}</strong></span>}
            </p>
          </div>
        </div>
      )}

      {/* Paket Seçenekleri - Çapraz Satış */}
      {successQuotes.length > 0 && (() => {
        const bestPrice = successQuotes[0].premium;
        const bestCompany = getDisplayName(successQuotes[0].companyCode, successQuotes[0].companyName);
        const packages = [
          {
            key: 'standart',
            title: 'Standart Trafik Sigortası',
            price: bestPrice,
            features: ['Zorunlu trafik teminatları'],
            color: 'border-gray-200',
            bg: 'bg-white',
            badge: null
          },
          {
            key: 'genisletilmis',
            title: 'Genişletilmiş Trafik Sigortası',
            price: bestPrice + 750,
            features: ['Zorunlu trafik teminatları', 'Yol Yardım (Arıza + Kaza, 4 kullanım)'],
            color: 'border-[#0189ec]',
            bg: 'bg-blue-50/50',
            badge: 'Önerilen'
          },
          {
            key: 'gelistirilmis',
            title: 'Geliştirilmiş Trafik Sigortası',
            price: bestPrice + 750 + 2000,
            features: ['Zorunlu trafik teminatları', 'Yol Yardım (Arıza + Kaza, 4 kullanım)', 'İMM (İhtiyari Mali Mesuliyet)'],
            color: 'border-green-400',
            bg: 'bg-green-50/50',
            badge: 'Tam Koruma'
          }
        ];
        return (
          <div className="mb-6">
            <h2 className="text-lg font-bold text-gray-800 mb-3">Paket Seçenekleri</h2>
            <p className="text-xs text-gray-400 mb-3">{bestCompany} baz alınarak hesaplanmıştır</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {packages.map((pkg) => (
                <div key={pkg.key} className={`relative rounded-xl p-4 border-2 ${pkg.color} ${pkg.bg} transition-all hover:shadow-md`}>
                  {pkg.badge && (
                    <div className={`absolute -top-2.5 left-3 px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${pkg.key === 'genisletilmis' ? 'bg-[#0189ec]' : 'bg-green-500'}`}>
                      {pkg.badge}
                    </div>
                  )}
                  <div className="text-sm font-semibold text-gray-800 mb-2 mt-1">{pkg.title}</div>
                  <div className="text-2xl font-bold text-gray-900 mb-3">{formatPrice(pkg.price)}<span className="text-xs font-normal text-gray-400 ml-1">/ yıl</span></div>
                  <ul className="space-y-1.5">
                    {pkg.features.map((f, i) => (
                      <li key={i} className="flex items-start gap-1.5 text-xs text-gray-600">
                        <svg className="w-3.5 h-3.5 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" /></svg>
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {/* Baslik */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-800">
          {loading ? 'Teklifler Yükleniyor...' : `Teklifler ${successQuotes.length > 0 ? `(${successQuotes.length})` : ''}`}
        </h2>
        <div className="flex items-center gap-3">
          {/* PDF butonu şimdilik devre dışı
          {pdfUrl && (
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer"
              className="px-3 py-1.5 bg-[#24b9fa] hover:bg-[#1da8e6] text-white text-sm font-medium rounded-lg transition-colors">
              PDF İndir
            </a>
          )}
          */}
        </div>
      </div>

      {/* System mesaji - gizli */}

      {/* Loading skeleton */}
      {loading && quotes.length === 0 && (
        <div className="space-y-3">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="bg-white/80 backdrop-blur-sm rounded-xl p-4 border border-gray-100 animate-pulse" style={{ animationDelay: `${i * 0.15}s` }}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-gray-200 to-gray-100 rounded-lg" />
                  <div>
                    <div className="w-28 h-4 bg-gray-200 rounded mb-2" />
                    <div className="w-16 h-3 bg-gray-100 rounded" />
                  </div>
                </div>
                <div className="w-20 h-7 bg-gray-200 rounded" />
              </div>
            </div>
          ))}
          <p className="text-center text-sm text-gray-400 mt-2">Sigo sigorta şirketlerinden teklifleri topluyor...</p>
        </div>
      )}

      {/* Basarili Teklifler */}
      <div className="space-y-3">
        {successQuotes.map((quote, index) => {
          const logoSrc = getCompanyLogo(quote.companyCode);
          const isBest = index === 0 && successQuotes.length > 1;
          return (
            <div key={quote.companyCode || index}
              className={`bg-white/90 backdrop-blur-sm rounded-xl p-4 border transition-all hover:shadow-lg animate-slide-up ${
                isBest
                  ? 'border-green-300 shadow-md shadow-green-100/50 ring-1 ring-green-200'
                  : 'border-gray-200 hover:border-[#24b9fa]/30'
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}>

              {isBest && (
                <div className="flex items-center gap-1.5 mb-3">
                  <div className="inline-flex items-center gap-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-2.5 py-0.5 rounded-full text-xs font-semibold shadow-sm">
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" /></svg>
                    Sigo Önerisi - En Uygun Fiyat
                  </div>
                </div>
              )}

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-lg bg-white border border-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0 shadow-sm">
                    {logoSrc ? (
                      <img src={logoSrc} alt={quote.companyName} className="w-10 h-10 object-contain" />
                    ) : (
                      <span className="text-lg font-bold text-gray-300">{quote.companyName?.charAt(0)}</span>
                    )}
                  </div>
                  <div>
                    <div className="font-semibold text-gray-800">{getDisplayName(quote.companyCode, quote.companyName)}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="text-right">
                    <div className={`text-xl font-bold ${isBest ? 'text-green-600' : 'text-gray-800'}`}>{formatPrice(quote.premium)}</div>
                    <div className="text-xs text-gray-400">yıllık</div>
                  </div>
                  {quote.paymentUrl && (
                    <a href={quote.paymentUrl} target="_blank" rel="noopener noreferrer"
                      className={`px-4 py-2.5 text-white text-sm font-semibold rounded-xl transition-all shadow-sm hover:shadow-md active:scale-95 ${
                        isBest
                          ? 'bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600'
                          : 'bg-[#0189ec] hover:bg-[#0070c9]'
                      }`}>
                      Satın Al
                    </a>
                  )}
                </div>
              </div>

              {/* Teminat Detayları - Açılır */}
              <button
                onClick={() => setExpandedCard(expandedCard === (quote.companyCode || index) ? null : (quote.companyCode || index))}
                className="mt-3 w-full flex items-center justify-center gap-1 text-xs text-gray-400 hover:text-[#0189ec] transition-colors py-1"
              >
                <span>Teminat Detayları</span>
                <svg className={`w-3.5 h-3.5 transition-transform ${expandedCard === (quote.companyCode || index) ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {expandedCard === (quote.companyCode || index) && (
                <div className="mt-2 pt-3 border-t border-gray-100 grid grid-cols-2 gap-2 text-xs animate-slide-up">
                  <div className="bg-gray-50 rounded-lg p-2.5">
                    <div className="text-gray-400 mb-0.5">Sağlık Gideri (Kişi)</div>
                    <div className="font-semibold text-gray-700">{coverage.saglikKisi} TL</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-2.5">
                    <div className="text-gray-400 mb-0.5">Sağlık Gideri (Kaza)</div>
                    <div className="font-semibold text-gray-700">{coverage.saglikKaza} TL</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-2.5">
                    <div className="text-gray-400 mb-0.5">Sakatlanma/Ölüm (Kişi)</div>
                    <div className="font-semibold text-gray-700">{coverage.olumKisi} TL</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-2.5">
                    <div className="text-gray-400 mb-0.5">Sakatlanma/Ölüm (Kaza)</div>
                    <div className="font-semibold text-gray-700">{coverage.olumKaza} TL</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-2.5">
                    <div className="text-gray-400 mb-0.5">Maddi Hasar (Araç)</div>
                    <div className="font-semibold text-gray-700">{coverage.maddiArac} TL</div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-2.5">
                    <div className="text-gray-400 mb-0.5">Maddi Hasar (Kaza)</div>
                    <div className="font-semibold text-gray-700">{coverage.maddiKaza} TL</div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Basarisiz Teklifler */}
      {failedQuotes.length > 0 && (completed || !loading) && (
        <div className="mt-6">
          <details className="group">
            <summary className="text-sm text-gray-400 cursor-pointer hover:text-gray-600 transition-colors">
              Teklif alınamayan şirketler ({failedQuotes.length})
            </summary>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-3">
              {failedQuotes.map((quote, index) => {
                const logoSrc = getCompanyLogo(quote.companyCode);
                let errorReason = 'Teklif alınamadı';
                const msg = (quote.message || '').toLowerCase();
                if (msg.includes('yaşayan poli') || msg.includes('yasayan poli')) errorReason = 'Mevcut poliçe var';
                else if (msg.includes('timeout') || msg.includes('zaman')) errorReason = 'Zaman aşımı';
                else if (msg.includes('hata')) errorReason = 'Sistem hatası';

                return (
                  <div key={quote.companyCode || index} className="bg-white/60 rounded-lg p-2.5 border border-gray-100 opacity-60">
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded bg-gray-50 border border-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                        {logoSrc ? (
                          <img src={logoSrc} alt={quote.companyName} className="w-5 h-5 object-contain" />
                        ) : (
                          <span className="text-xs font-bold text-gray-300">{quote.companyName?.charAt(0)}</span>
                        )}
                      </div>
                      <div className="min-w-0">
                        <div className="font-medium text-gray-600 text-xs truncate">{getDisplayName(quote.companyCode, quote.companyName)}</div>
                        <div className="text-xs text-red-400 truncate">{errorReason}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </details>
        </div>
      )}

      {/* Yeni Sorgu */}
      {completed && (
        <div className="mt-6 text-center">
          <button onClick={onNewQuery}
            className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-white hover:shadow-sm transition-all">
            Yeni Sorgu Yap
          </button>
        </div>
      )}
    </div>
  );
};

export default OnlineTrafikSigortasi3;
